import produce from 'immer';
import {
  ALLOWED_IP_CREATE, ALLOWED_IP_LIST_REQUEST, ALLOWED_IP_REMOVE, SET_ALLOWED_IP_LIST, SET_IP_PAGE,
  SET_TOTAL_COUNT
} from '../../constants/backoffice/ipConstants';

const initialState = {
  allowedIpList: [],
  page: 1,
  pageLength: 5,
  totalCount: 0,
};

/* eslint-disable default-case, no-param-reassign */
const ipReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case ALLOWED_IP_LIST_REQUEST:
    case ALLOWED_IP_REMOVE:
    case ALLOWED_IP_CREATE:
      break;

    case SET_ALLOWED_IP_LIST:
      draft.allowedIpList = action.allowedIpList;
      break;

    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;

    case SET_IP_PAGE:
      draft.page = action.page;
      break;
  }
});

export default ipReducer;
